const calendarRefs = Object.freeze({
    hour: 60,
    halfAnHour: 30,
    minimumPeriod: 24,
    minimumPeriodHeight: 28,
    initialPixelBasePerMinute: 1.2
});

export default calendarRefs;
